import { styled } from '@mui/material'
import { useAvailableOrganisations } from '@omnea-app/fe-auth/useAvailableOrganisations'
import { containsOnlyOne } from '@omnea-app/packages/universal/general/arrays'
import { MultipleOrganisationPicker } from './MultipleOrganisationPicker'
import { OrganisationLogo } from './OrganisationLogo'

export const OrganisationIndicator: React.FC = () => {
  const { data, isLoading } = useAvailableOrganisations()
  const { availableOrganisations } = data || { availableOrganisations: [] }

  if (isLoading) return <Wrapper sx={{ width: 150 }} />

  const hasMultipleOrgs = availableOrganisations.length > 1

  if (hasMultipleOrgs) {
    return <MultipleOrganisationPicker availableOrganisations={availableOrganisations} />
  }

  if (!containsOnlyOne(availableOrganisations)) return null

  // If there is only one organisation, we don't need to show the picker
  return (
    <Wrapper>
      <OrganisationLogo organisation={availableOrganisations[0]} />
    </Wrapper>
  )
}

export const Wrapper = styled('div')(({ theme }) => ({
  height: 50,
  padding: `${theme.spacing(3)} ${theme.spacing(6)}`,
  border: 'none',
  borderLeft: '1px solid',
  borderColor: theme.palette.divider,
  display: 'grid',
  alignItems: 'center',
}))
